import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpClientService } from '../common/http-client.service';

import { AutocompleteResult } from '../../models/autocomplete-result';

@Injectable()
export class MatterSearchService {
  /**
   * Matter field search URL
   * @type {String}
   */
  private mattersFieldSearchURL = 'matters/field_search';

  /**
   * URL for matters controller
   * @type {String}
   */
  private mattersURL = 'matters';

  /**
   * Constructor
   * @param {HttpClientService} private httpClient Service for making HTTP requests with different methods
   */
  constructor(private httpClient: HttpClientService) {}

  /**
   * Find matter by number
   * @param  {string}       matter_number Number of matter
   * @return {Promise<any>}               Server response with matter
   */
  findByNumber(matter_number: string): Promise<any> {
    return this.httpClient.get(`${this.mattersURL}.json`, { find_by_number: true, matter_number: matter_number });
  }

  /**
   * Get matter info by id
   * @param  {[type]}       id Id of matter
   * @return {Promise<any>}    Server response with matter info
   */
  getMatterInfo(id: number): Promise<any> {
    return this.httpClient.get(`${this.mattersURL}/${id}.json`, { get_name_number: true });
  }

  /**
   * Search matters using a search term
   * @param  {[type]}                           term Matter search term
   * @return {Observable<AutocompleteResult[]>}      Server response with autocomplete results
   */
  mattersFieldSearch(term: string): Observable<AutocompleteResult[]> {
    return this.httpClient.getObservable(`${this.mattersFieldSearchURL}.json?term=${term}`).pipe(map((response) => response as AutocompleteResult[]));
  }
}
